import { getRoute } from "@/getters/getRoute";
import { mini_carousel_helper } from "@/helpers/mini_carousel_helper";
import { trimText } from "@/functions/trimText";
import { sector_helper } from "@/helpers/sector_helper";
import { createTitle } from "@/functions/createTitle";

export const getSectorStaticProps = ({ sector_id, pages_helper = null, pages = null } = {}) => {
  const sector = sector_helper.find(sector_id, "id");

  let content = [
    {
      component: "BreadcrumbNavigation",
      props: {
        items: [{ label: sector.title, href: getRoute("sector", { url_slug: sector.url_slug }) }],
      },
    },
    {
      component: "Header",
      props: {
        className: "text-tertiary",
        title:  { path: `page.${sector.url_slug}.component.Header.title`, placeholder: sector.title } ?? sector.title ,
        description: { path: `page.${sector.url_slug}.component.Header.description` },     
        img: sector.cover_image ?? null,
        variant: "50/50",
        back: {
          path: `page.home.component.Header.back`,
          placeholder: `Back to Home`,
          href: getRoute("home"),
        },
      },
    },
    {
      component: "JobsFeed",
      id: "Jobs",
      props: { sector: sector.id, changeURLOnFilterChange: false },
    },
    {
      component: "RichText",
      props: {
        className: "mb-4",
        containerClassName: null,
        body: sector.footer_content ?? null,
      },
    },
  ];

  if (pages == 'officejobs') {
    content.filter({
      component: "RichText",
      props: { className: "bg-primary text-white py-4 py-md-5", body: sector.body ?? null },
    });
  }


  content.push({
    component: "MiniCarousel",
    props: {
      items: mini_carousel_helper.fetch({
        filter: (i) =>
          i.tags.toLowerCase().includes(sector.url_slug.toLowerCase()) ||
          i.tags.toLowerCase().includes(sector.title.toLowerCase()) ||
          i.tags.includes("*"),
      }),
    },
  });

  if (pages) {
    content.push({
      component: "PromoSection",
      props: {
        title: { path: `page.${sector.url_slug}.component.PromoSection.title`, placeholder: "Also in this section" },
        items: pages.map((i) => ({
          title: i.title ?? null,
          description: trimText(i.body),
          img: i.cover_image ?? null,
          href: getRoute("sectorPage", { sector: sector.url_slug, page: i.url_slug }),
        })),
        md: 3,
      },
    });
  } else if (pages_helper) {
    pages = pages_helper.fetch({ parent: null });

    content.push({
      component: "PromoSection",
      props: {
        title: { path: `page.${sector.url_slug}.component.PromoSection.title`, placeholder: "Also in this section" },
        items: pages.map((i) => ({
          title: i.name,
          description: trimText(i.body),
          img: i.cover_image ?? null,
          href: getRoute("sectorPage", { sector: sector.url_slug, page: i.url_slug }),
        })),
        md: 3,
      },
    });
  }

  content.push(
    { component: "Divider" },
    {
      component: "RichText",
      props: {
        className: "py-4 py-md-5",
        containerClassName: null,
        body: {
          path: `page.${sector.url_slug}.component.RichText.body`
        },
      },
    },
);

  return {
    props: {
      meta: {
        title: createTitle(`${sector.title} Jobs`),
        canonical: "https://www.bluearrow.co.uk" + getRoute("sector", { url_slug: sector.url_slug }),
      },
      content,
    },
  };
};
